/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Pro_7Inputs */

const en_signup_feature_pro_7 = /** @type {(inputs: Signup_Feature_Pro_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pre-built 3rd Party Platform Integrations (ICONIK)`)
};

const fr_signup_feature_pro_7 = /** @type {(inputs: Signup_Feature_Pro_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intégrations de plateformes tierces préconfigurées (ICONIK)`)
};

const de_signup_feature_pro_7 = /** @type {(inputs: Signup_Feature_Pro_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorkonfigurierte Integrationen von Drittanbieterplattformen (ICONIK)`)
};

const it_signup_feature_pro_7 = /** @type {(inputs: Signup_Feature_Pro_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrazioni di piattaforme di terze parti predefinite (ICONIK)`)
};

const ru_signup_feature_pro_7 = /** @type {(inputs: Signup_Feature_Pro_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Встроенные интеграции со сторонними платформами (ICONIK)`)
};

const es_signup_feature_pro_7 = /** @type {(inputs: Signup_Feature_Pro_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integraciones de plataformas de terceros prediseñadas (ICONIK)`)
};

const zh_cn2_signup_feature_pro_7 = /** @type {(inputs: Signup_Feature_Pro_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预构建的第三方平台集成（ICONIK）`)
};

const ja_signup_feature_pro_7 = /** @type {(inputs: Signup_Feature_Pro_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事前に構築されたサードパーティプラットフォーム統合（ICONIK）`)
};

const hi_signup_feature_pro_7 = /** @type {(inputs: Signup_Feature_Pro_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्वनिर्मित तृतीय-पक्ष प्लेटफ़ॉर्म एकीकरण (ICONIK)`)
};

const pt_pt2_signup_feature_pro_7 = /** @type {(inputs: Signup_Feature_Pro_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrações pré-construídas com plataformas de terceiros (ICONIK)`)
};

/**
* | output |
* | --- |
* | "Pre-built 3rd Party Platform Integrations (ICONIK)" |
*
* @param {Signup_Feature_Pro_7Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_pro_7 = /** @type {((inputs?: Signup_Feature_Pro_7Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Pro_7Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_feature_pro_7(inputs)
	if (locale === "de") return de_signup_feature_pro_7(inputs)
	if (locale === "it") return it_signup_feature_pro_7(inputs)
	if (locale === "ru") return ru_signup_feature_pro_7(inputs)
	if (locale === "es") return es_signup_feature_pro_7(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_feature_pro_7(inputs)
	if (locale === "ja") return ja_signup_feature_pro_7(inputs)
	if (locale === "hi") return hi_signup_feature_pro_7(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_feature_pro_7(inputs)
	return en_signup_feature_pro_7(inputs)
});